import { render, staticRenderFns } from "./TechFeatures.vue?vue&type=template&id=74ca6aa0&scoped=true&"
var script = {}
import style0 from "./TechFeatures.vue?vue&type=style&index=0&id=74ca6aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca6aa0",
  null
  
)

export default component.exports